import { useMemo } from 'react';

import EventInfoRow from './event-info-row';

type Props = {
  shares: string;
  totalCost: number;
};

const EventBuyProfitMultiplierRow = ({ shares, totalCost }: Props) => {
  const profitMultiplier = useMemo(() => {
    return (+shares / (totalCost || 1)).toFixed(2);
  }, [shares, totalCost]);

  return (
    <EventInfoRow
      title="Multiplier"
      className="text-primary-cta text-[14px] font-medium md:text-[18px]"
      content={<p>{profitMultiplier}x</p>}
    />
  );
};

export default EventBuyProfitMultiplierRow;
